<template>
  <img :src="avatarUrl" alt="foto de perfil" :width="size" :height="size" />
</template>

<script>
import { usePhysicianStore } from '@/store/pinia/physician'

export default {
  props: {
    size: {
      type: Number,
      default: 82,
    },
  },
  computed: {
    avatarUrl() {
      return this.physicianStore.avatarUrl
    },
  },
  setup() {
    const physicianStore = usePhysicianStore()

    return {
      physicianStore,
    }
  },
}
</script>

<style scoped>
img {
  border-radius: 50%;
}
</style>
